export const Constants = {
  TAG_NAME: 'pop-sector-attribution-chart-component',
  TOTAL_VALUE_ADDED_LABEL: 'Total value added',
  VALUE_FROM_SECTOR_WEIGHT_LABEL: 'Value from sector weight',
  VALUE_FROM_STOCK_SELECTION_LABEL: 'Value from stock selection',
  Y_AXIS_LABEL: 'Value added, %',
  X_AXIS_LABEL: 'Sector',
} as const;
